import { KaiApp } from './app';

document.addEventListener('DOMContentLoaded', () => {
  const app = new KaiApp();
  void app.init();
});
